import React from 'react'
import { slide as Menu } from 'react-burger-menu'
import { observer, inject } from 'mobx-react'
import Sidebar from './Sidebar'

const BurgerMenu = inject('uiStore')(observer(props => {
  const { isOpen } = props.uiStore.state.sidebar
  return (
    <Menu isOpen={isOpen} onStateChange={(value) => props.uiStore.setIsOpen(value.isOpen)} customBurgerIcon={false}>
      <Sidebar />
    </Menu>
  )
}))

export default BurgerMenu



// WEBPACK FOOTER //
// ./src/components/dashboard/BurgerMenu.js